/* eslint-disable import/prefer-default-export */

export const BREAKPOINT_BELOW_XS = 'max-width: 360px';

export const BREAKPOINT_BELOW_M = (props) =>
  `max-width: ${parseInt(props.theme.SizeBreakpointsM, 10) - 1}px`;
